// src/routing/PrivateRoutes.jsx
import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import api, { getToken, setToken, saveReturnTo, isTokenValid, clearAuth } from "../utils/axiosConfig";

/**
 * ✅ PrivateRoutes
 * - Protect routes requiring auth
 * - 1) valid local token -> allow
 * - 2) else try refresh cookie -> allow if valid token returned
 * - 3) else redirect to /identification
 */
export const PrivateRoutes = ({ children }) => {
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const [ok, setOk] = useState(false);

  useEffect(() => {
    let alive = true;

    const checkAuth = async () => {
      // ✅ getToken() already returns ONLY a valid token or null
      const localToken = getToken();

      if (localToken) {
        if (!alive) return;
        setOk(true);
        setChecking(false);
        return;
      }

      // ✅ try refresh cookie
      try {
        const res = await api.post("user/refresh", {}, { withCredentials: true });
        const newToken = res.data?.token || res.data?.accessToken;

        if (!alive) return;

        if (newToken && isTokenValid(newToken)) {
          setToken(newToken);
          setOk(true);
        } else {
          try {
            clearAuth();
          } catch {}
          setOk(false);
        }
      } catch {
        if (!alive) return;
        setOk(false);
      } finally {
        if (!alive) return;
        setChecking(false);
      }
    };

    checkAuth();

    return () => {
      alive = false;
    };
  }, []);

  if (checking) return null;

  if (!ok) {
    try {
      saveReturnTo?.();
    } catch {}

    return (
      <Navigate
        to="/identification"
        state={{ returnTo: `${location.pathname}${location.search || ""}`, from: location }}
        replace
      />
    );
  }

  return children;
};